import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { handleChangePassword, handleUserUpdate } from "../app/authSlice";
import { useAuth } from "./useAuth";

export const useSettings = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const { isLoading, user, error } = authState;
  const { handleAvatar } = useAuth();

  const [preview, setPreview] = useState(user?.avatar);
  const [userData, setUserData] = useState({
    username: authState.user?.username,
    email: authState.user?.email,
    discord: authState.user?.discord,
    facebook: authState.user?.facebook,
    twitter: authState.user?.twitter,
    instagram: authState.user?.instagram,
  });
  const [pwdInfo, setPwdInfo] = useState({});

  const handleSettingAvatar = async (e) => {
    e.preventDefault();
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 1024 * 1024) {
      toast.warning("Bild zu groß — maximal 1 MB.");
      e.target.value = "";
      return;
    }
    const result = await handleAvatar(e);
    const url = typeof result === "string" ? result : result?.url;
    if (!url) {
      const detail =
        (result && typeof result === "object" && result.error) ||
        "Bitte anderes Bild versuchen (JPG/PNG, max. 1 MB).";
      toast.error(`Upload fehlgeschlagen: ${detail}`);
      e.target.value = "";
      return;
    }
    setPreview(url);
    // Sofort speichern — sonst bleibt avatar in der DB null (nur Preview).
    try {
      const result = await dispatch(
        handleUserUpdate({ ...userData, avatar: url })
      ).unwrap();
      if (result?.data?.updatedUser?.avatar) {
        toast.success("Profilbild gespeichert.");
      } else {
        toast.warning("Bild hochgeladen — bitte unten noch „Speichern“ tippen.");
      }
    } catch (err) {
      toast.error(
        err?.message ||
          "Bild hochgeladen, Speichern fehlgeschlagen — bitte unten Speichern tippen."
      );
    }
  };

  const onUserDataChange = (e) => {
    setUserData({ ...userData, ...e });
  };

  const handleUserInfo = async (e) => {
    e.preventDefault();
    dispatch(handleUserUpdate({ ...userData, avatar: preview }));
  };

  const onChangePwd = (e) => {
    setPwdInfo({ ...pwdInfo, ...e });
  };

  const handlePwdChange = async (e) => {
    e.preventDefault();
    if (pwdInfo.newpassword !== pwdInfo.confirmpassword)
      return toast.warning("New password and confirm password must match!");
    dispatch(
      handleChangePassword({
        currentPassword: pwdInfo.currentpassword,
        newPassword: pwdInfo.newpassword,
      })
    );
  };

  return {
    isLoading,
    preview,
    userData,
    error,
    handleSettingAvatar,
    onUserDataChange,
    handleUserInfo,
    onChangePwd,
    handlePwdChange,
  };
};
